import { render, staticRenderFns } from "./CalendarTopBar.vue?vue&type=template&id=4b5f2103&scoped=true"
import script from "./CalendarTopBar.vue?vue&type=script&lang=ts"
export * from "./CalendarTopBar.vue?vue&type=script&lang=ts"
import style0 from "./CalendarTopBar.vue?vue&type=style&index=0&id=4b5f2103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f2103",
  null
  
)

export default component.exports